// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1QA8T","modalForm":"UpgradeEpcsModal_modalForm__eDW5P","modalFooter":"UpgradeEpcsModal_modalFooter__GBk_h"};